







































import Vue from "vue";
import { required } from "vuelidate/lib/validators";
import { Shop } from "../../shop/models/Shop";
import { ShopTMSRegisterForm } from "../forms/ShopTMSRegisterForm";
import dialog from "@/common/mixins/dialog";
export default Vue.extend({
  mixins: [dialog],
  validations: {
    shopTMSRegisterForm: {
      name: { required },
      email: { required },
      tel: { required }
    }
  },
  data() {
    const shops: Shop[] = [];
    const shopTMSRegisterForm: ShopTMSRegisterForm = {
      name: "",
      email: "",
      tel: ""
    };
    return { shops, shopTMSRegisterForm };
  },
  async created() {
    await Promise.all([this.getShops()]);
  },
  computed: {
    nameError() {
      return (this as any).$v.shopTMSRegisterForm.name.$error
        ? "Name is required"
        : "";
    },
    emailError() {
      return (this as any).$v.shopTMSRegisterForm.email.$error
        ? "Email is required"
        : "";
    },
    telError() {
      return (this as any).$v.shopTMSRegisterForm.tel.$error
        ? "Tel is required"
        : "";
    }
  },
  methods: {
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async registerTMS() {
      try {
        const { data } = await (this as any).$dep.tmsUseCase.registerShop(
          this.shopTMSRegisterForm
        );
        (this as any).alertSuccess(
          "Success",
          "Successfully Register with uuid: " + data.uuid
        );
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          (this as any).alertError("Error", error);
        }
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;

      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to register Shop",
        "คุณต้องการลงทะเบียนร้านค้า หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.registerTMS();
      }
    },
    clear() {
      this.$v.$reset();
    }
  }
});
